import * as React from "react";

import "./analytics-blog.scss";
import { OmniSearchCarousel } from "@Xpresso/routes/omni-search/omni-search-layout/omni-search-carousel/omni-search-carousel";
import { Shimmer } from "@Xpresso/routes/omni-search/omni-search-layout/common/shimmer/shimmer";
import { Blog } from "@Xpresso/routes/omni-search/omni-search-layout/explore-layout/blogs/blogs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as FontAwesome from "@fortawesome/free-solid-svg-icons";

const WIDTH_COMPONENT = 323
const EDGE_ITEM_DIVISOR = 6

export const AnalyticsBlog = ({blogs, settings, emptyState = false}) => {
    const url = window.location.href
    const app = '/app'
    const urlBlog = url.split(app)[0] + '/s/blog/'

    if(!Array.isArray(blogs)) {
        return null
    }

    blogs = blogs.filter(blog => blog?.categories?.includes(settings?.blogCategory))

    if(blogs.length < 1) {
        return null
    }

    return (
        <div className="blogs-yeet3">
            <div className="heading">
                <div className="text">
                    Want more leads?
                </div>
                <div className="sub-text">
                    Checkout out our marketing resources for more help
                </div>
            </div>
            <OmniSearchCarousel
                Component={emptyState ? Blog : AnalyticsBlogComponent}
                items={blogs}
                widthComponent={WIDTH_COMPONENT}
                edgeItemVisibilityDivisor={EDGE_ITEM_DIVISOR}
                additionalProps={{urlBlog}}
            />
        </div>
    )
};

export const AnalyticsBlogComponent = ({item:blog, urlBlog}) => {
    const [thumbnailLoaded, setThumbnailLoaded] = React.useState(false)
    const thumbnail = blog?.thumbnail ? blog.thumbnail : ''

    return (
        <a
            className="blog-yeet4"
            target="_blank"
            href={`${urlBlog}${blog.slug}`}
        >
            {!thumbnailLoaded && <Shimmer name={"image-container"} />}
            {
                <div
                    className="image-container"
                    style={{display: thumbnailLoaded ? 'flex' : 'none'}}
                >
                    <img
                        src={thumbnail}
                        alt={`image-${blog.slug}`}
                        onLoad={() => setThumbnailLoaded(true)}
                    />
                </div>
            }
            <div className="title">
                {blog.title}
            </div>
        </a>
    )
}

export const AnalyticsCalloutBlogComponent = ({name, urlBlog, callout, iconName}) => {
    const url = window.location.href
    const app = '/app'
    const linkUrl = url.split(app)[0] + '/s/blog/' + urlBlog
    return (
        <a
            className="callout-blog-yeet5"
            target="_blank"
            href={linkUrl}
        >   <div className="icon">
                <FontAwesomeIcon icon={FontAwesome[`fa${iconName.charAt(0).toUpperCase() + iconName.slice(1)}`]} />
            </div>
            <div className="text">
                <div className="title">
                    {callout}
                </div>
                <div className="sub-title">
                    Check out <span className="link">{name}</span>
                </div>
            </div>
        </a>
    )
}
